<h3 class="mb-8 text-xl text-grey">
  {{ 'pages.uploadFile.steps.upload.description' | translate }}
</h3>

<div class="flex max-w-screen-xl flex-col gap-6">
  <nz-upload
    class="block"
    nzType="drag"
    nzAccept=".csv"
    nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
    [nzBeforeUpload]="beforeUpload"
  >
    <div
      class="flex flex-col items-center gap-4 rounded-md border border-dashed border-grey-300 p-6"
    >
      <svg-icon
        src="assets/icons/General/upload-01.svg"
        class="size-16 text-grey-300"
      />
      <p>
        <strong>
          @if (file) {
            <span data-test-id="fileName">{{ file.name }}</span>
          } @else {
            {{ 'pages.uploadFile.steps.upload.selectFile' | translate }}
          }
        </strong>
      </p>
      <p class="text-sm">
        {{ 'pages.uploadFile.steps.upload.help' | translate }}
      </p>
    </div>
  </nz-upload>

  @if (file) {
    <div>
      @if (fileLineCount > 10) {
        <p data-test-id="filePreviewHeadlineOverlap" class="my-2 px-2 text-sm">
          {{
            `pages.uploadFile.steps.upload.previewOverlap`
              | translate: { count: fileLineCount }
          }}
        </p>
      } @else {
        <p data-test-id="filePreviewHeadline" class="my-2 px-2 text-sm">
          {{
            `pages.uploadFile.steps.upload.preview`
              | translate: { count: fileLineCount }
          }}
        </p>
      }
      <div class="w-full overflow-x-auto">
        <nz-table
          #csvPreviewTable
          nzSize="small"
          data-test-id="filePreviewTable"
          nzTableLayout="auto"
          [nzData]="filePreviewData ?? []"
          [nzShowPagination]="false"
        >
          <thead>
            @for (row of filePreviewData; track $index; let first = $first) {
              @if (first) {
                <tr>
                  @for (col of row; track $index) {
                    <th scope="col" class="whitespace-nowrap">{{ col }}</th>
                  }
                </tr>
              }
            }
          </thead>
          <tbody>
            @for (row of filePreviewData; track $index; let first = $first) {
              @if (!first) {
                <tr>
                  @for (col of row; track $index) {
                    <td class="whitespace-nowrap">{{ col }}</td>
                  }
                </tr>
              }
            }
          </tbody>
        </nz-table>
      </div>
    </div>
  }

  <div class="flex justify-between">
    <app-button data-test-id="cancelFile" type="outline" routerLink="../">
      {{ 'pages.uploadFile.cancelButton.label' | translate }}
    </app-button>
    <app-button
      data-test-id="submitFile"
      type="primary"
      [disabled]="!file"
      (trigger)="uploadSubmit()"
    >
      {{ 'pages.uploadFile.steps.upload.next' | translate }}
    </app-button>
  </div>
</div>
